import { createSlice } from '@reduxjs/toolkit';

import axios from 'utils/axios';
import { dispatch } from '../index';

const initialState = {
    error: null,
    selectedWorkspace: null,
    billing: null,
    invoiceList: [],
    workspaces: [],
    users: [],
    userCount: null,
    licenseCount: null,
    subscribedOrderTopic: false,
    orderStatus: null,
};

const slice = createSlice({
    name: 'workspace',
    initialState,
    reducers: {
        hasError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else if(action.payload.response ? (action.payload.response.status == 403) : (action.payload.status == 403)) {
                window.location.pathname = 'forbidden'
            } else {
                state.error = action.payload;
            }
        },
        hasWorkspaceError(state, action) {
            if(action.payload.response ? (action.payload.response.status == 401) : (action.payload.status == 401)) {
                window.location.pathname = 'login'
            } else if(action.payload.response ? (action.payload.response.status == 403) : (action.payload.status == 403)) {
                if(localStorage.getItem('workspaceId')) {
                    localStorage.removeItem('workspaceId')
                    window.location.pathname = '/'
                } else {
                    window.location.pathname = 'forbidden'
                }
            } else {
                state.error = action.payload;
            }
        },
        getWorkspacesSuccess(state, action) {
            state.workspaces = action.payload.workspaceList;
        },
        getUsersSuccess(state, action) {
            state.users = action.payload.userList;
            state.userCount = action.payload.total;
            state.licenseCount = action.payload.licenseCount;
        },
        selectWorkspace(state, action) {
            state.selectedWorkspace = action.payload;
        },
        getBillingSuccess(state, action) {
            state.billing = action.payload.billing;
            state.invoiceList = action.payload.invoiceList;
        },
        setSubscribedOrderTopic(state, action) {
            state.subscribedOrderTopic = action.payload;
        },
        setOrderStatus(state, action) {
            state.orderStatus = action.payload;
        },
    }
});

export default slice.reducer;

export const { selectWorkspace, setSubscribedOrderTopic, setOrderStatus } = slice.actions;

// An action to start stomp connection.
export const connectStomp = (id) => ({ type: 'connect', gentype: 'order', id });

// An action to disconnect stomp connection.
export const disconnectStomp = () => ({ type: 'disconnect' });

// An action to unsubscribe stomp topic.
export const unsubscribeTopic = (id) => ({ type: 'unsubscribe', gentype: 'order', id});

export function getPath(data, callback) {
    return async () => {
        try {
            const response = await axios.get('/api/workspace/path', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                },
                params: data
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasWorkspaceError(e));
        }
    };
}

export function getWorkspaces(callback) {
    return async () => {
        try {
            const response = await axios.get('/api/workspace/list', {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`
                }
            });
            dispatch(slice.actions.getWorkspacesSuccess(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updatetWorkspace(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/workspace/update', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.getWorkspacesSuccess(response.data));
            if(callback){
                callback();
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getUsers(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/workspace/user/list', data, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            dispatch(slice.actions.getUsersSuccess(response.data));
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function inviteUser(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/workspace/user/invite', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if(callback){
                callback(response.data);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function changeRole(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/workspace/user/role', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            }
            );
            if(callback){
                callback(response.data);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function resendInvitation(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/workspace/user/re-invite', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if(callback){
                callback(response.data);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function removeUser(data, callback) {
    return async () => {
        try {
            const response = await axios.post('/api/workspace/user/remove', data, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                }
            });
            if(callback){
                callback(response.data);
            }
        } catch (error) {
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function getBilling(data, callback) {
    return async () => {
        try {
            const response = await axios.get(`/api/workspace/${data}/billing/details`, {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                },
            });
            dispatch(slice.actions.getBillingSuccess(response.data));
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function updateBillingAddress(data, callback) {
    return async () => {
        try {
            const response = await axios.post(`/api/workspace/billing/update`, data,
                {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                },
            });
            if (callback) {
                callback();
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getCheckoutUrl(data, callback) {
    return async () => {
        try {
            const response = await axios.post(`/api/subscription/upgrade`, data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                },
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function getInvoice(data, callback) {
    return async () => {
        try {
            const response = await axios.post(`/api/workspace/invoice`, data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                },
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function unsubscribe(data, callback) {
    return async () => {
        try {
            const response = await axios.post(`/api/subscription/cancel`, data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                },
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}

export function resubscribe(data, callback) {
    return async () => {
        try {
            const response = await axios.post(`/api/subscription/resubscribe`, data,
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
                    'X-Workspace-ID': localStorage.getItem('workspaceId')
                },
            });
            if (callback) {
                callback(response.data);
            }
        } catch (e) {
            dispatch(slice.actions.hasError(e));
        }
    };
}